import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getDemobilization = createAsyncThunk(
  "/demobilization/demobilize",
  async (token, type) => {
    try {
      const response = await nodeinstance.put("/demobilization/demobilize", {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data);
      return response.data.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const DemobilizationSummary = createSlice({
  name: "dependentSummary",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDemobilization.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getDemobilization.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDemobilization.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getDemobilization };
export default DemobilizationSummary.reducer;
